/* eslint-disable no-new */
import Swiper from 'swiper/swiper-bundle';

export default class Slider {
	constructor({ elements }) {
		elements.forEach((el) => {
			const swiper = new Swiper(el, {
				// Optional parameters
				loop: false,
				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
				},
				watchSlidesProgress: true,
				slidesPerView: 'auto',
				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
			Slider.sliderNavigation(swiper, false);
			Slider.addEventListeners(swiper, false);
			el.removeAttribute('data-slider');
		});
	}

	static addEventListeners(swiper, hasDisabledButton) {
		swiper.on('slideChange', () => {
			Slider.sliderNavigation(swiper, hasDisabledButton);
		});
	}

	static sliderNavigation(swiper, hasDisabledButton) {
		Slider.checkBeginningSlider(swiper);
		Slider.checkEndSlider(swiper, hasDisabledButton);
	}

	static checkBeginningSlider(swiper) {
		if (swiper.isBeginning) {
			swiper.navigation.prevEl.classList.add('hide');
		} else if (swiper.navigation.prevEl.classList.contains('hide')) {
			swiper.navigation.prevEl.classList.remove('hide');
		}
	}

	static checkEndSlider(swiper, hasDisabledButton) {
		if (swiper.isEnd) {
			if (hasDisabledButton) {
				swiper.navigation.nextEl.classList.add('swiper-button-disabled');
			} else {
				swiper.navigation.nextEl.classList.add('hide');
			}
		} else if (hasDisabledButton) {
			swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
		} else if (swiper.navigation.nextEl.classList.contains('hide')) {
			swiper.navigation.nextEl.classList.remove('hide');
		}
	}
}
